/* eslint react/forbid-prop-types: 0 */
import React from "react";
import PropTypes from "prop-types";
import JobItemStatus from "../helpers/JobItemStatus";

const PICKUP_CODES = {
  OC: "Order Canceled",
  DI: "Damaged Items",
  SI: "Stock Issue"
};
const DELIVERY_CODES = {
  CR: "Customer Rejected",
  DG: "Damaged Goods",
  GL: "Gates Locked",
  MI: "Mechanical Issue"
};

const LoadVarianceHelper = loadedVarianceCode => {
  if (loadedVarianceCode) {
    return PICKUP_CODES[loadedVarianceCode.code] || "";
  }
  return "";
};
const DeliveryVarianceHelper = unloadedVarianceCode => {
  if (unloadedVarianceCode) {
    return DELIVERY_CODES[unloadedVarianceCode.code] || "";
  }
  return "";
};

const CompletedJobItem = ({ job, jobItems }) => {
  const data = jobItems.map(jobItem => (
    <tr className="content" key={jobItem.id}>
      <td>{jobItem.id}</td>
      <td>{jobItem.item.description}</td>
      <td>{jobItem.item.quantity}</td>
      <td>
        <JobItemStatus job={job} jobItem={jobItem} />
      </td>
      <td>
        {job.type === "DELIVERY"
          ? DeliveryVarianceHelper(jobItem.unloadedVarianceCode)
          : LoadVarianceHelper(jobItem.loadedVarianceCode)}
      </td>
    </tr>
  ));
  return <tbody>{data}</tbody>;
};
CompletedJobItem.propTypes = {
  job: PropTypes.object.isRequired,
  jobItems: PropTypes.array.isRequired
};

export default CompletedJobItem;



// WEBPACK FOOTER //
// ./src/components/jobs/show/CompletedJobItem.js